import styled, { keyframes } from 'styled-components';

export const SidebarOverlay = styled.div`
  position: fixed;
  inset: 0;
  z-index: 100000;
  background: rgba(0, 0, 0, 0.6);
  backdrop-filter: blur(8px);
`;

export const SidebarContainer = styled.div`
  position: fixed;
  right: 0;
  top: 0;
  z-index: 100001;
  height: 100%;
  width: 92vw;
  max-width: 420px;
  transform: ${props => props.open ? 'translateX(0)' : 'translateX(100%)'};
  transition: transform 0.3s ease;
`;

export const SidebarPanel = styled.div`
  position: relative;
  height: 100%;
  overflow: hidden;
  border-left: 1px solid rgba(255, 255, 255, 0.1);
  background: linear-gradient(to bottom, #070B14, #070A12, #050812);
  box-shadow: 0 40px 120px rgba(0, 0, 0, 0.75);
  outline: none;
`;

export const NeonGlow = styled.div`
  pointer-events: none;
  position: absolute;
  inset: -48px;
  opacity: 0.4;
  filter: blur(32px);
  
  &::before {
    content: '';
    position: absolute;
    left: 24px;
    top: 40px;
    width: 224px;
    height: 224px;
    border-radius: 50%;
    background: rgba(6, 182, 212, 0.3);
  }
  
  &::after {
    content: '';
    position: absolute;
    right: 32px;
    top: 96px;
    width: 256px;
    height: 256px;
    border-radius: 50%;
    background: rgba(139, 92, 246, 0.25);
  }
`;

export const SidebarHeader = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  background: rgba(255, 255, 255, 0.03);
  padding: 16px;
  backdrop-filter: blur(12px);
`;

export const HeaderLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const WalletIconContainer = styled.div`
  display: grid;
  place-items: center;
  width: 40px;
  height: 40px;
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.05);
`;

export const HeaderTitle = styled.div`
  font-size: 14px;
  font-weight: 600;
  color: #e5e7eb;
`;

export const HeaderSubtitle = styled.div`
  font-size: 12px;
  color: rgba(255, 255, 255, 0.5);
`;

export const HeaderActions = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const SidebarIconButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 12px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  background: rgba(255, 255, 255, 0.05);
  color: rgba(255, 255, 255, 0.8);
  cursor: pointer;
  padding: 8px;
  transition: all 0.2s ease;
  
  &:hover {
    background: rgba(255, 255, 255, 0.1);
    color: #fff;
  }
  
  &:focus {
    outline: none;
    box-shadow: 0 0 0 2px rgba(6, 182, 212, 0.5);
  }
`;

export const SidebarBody = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  height: calc(100% - 72px);
  overflow-y: auto;
  overflow-x: hidden;
  min-height: 0;

  /* Custom scrollbar styling */
  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-track {
    background: rgba(255, 255, 255, 0.05);
    border-radius: 3px;
  }

  &::-webkit-scrollbar-thumb {
    background: rgba(255, 255, 255, 0.2);
    border-radius: 3px;
    transition: background 0.2s ease;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: rgba(255, 255, 255, 0.3);
  }

  /* Firefox scrollbar */
  scrollbar-width: thin;
  scrollbar-color: rgba(255, 255, 255, 0.2) rgba(255, 255, 255, 0.05);
`;

export const SectionContainer = styled.div`
  padding: 16px;
  flex-shrink: 0;
`;

export const SectionHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
`;

export const SectionTitle = styled.div`
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: rgba(255, 255, 255, 0.4);
`;

export const SectionHint = styled.div`
  font-size: 12px;
  color: rgba(255, 255, 255, 0.4);
`;

export const BalanceCard = styled.div`
  border-radius: 16px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  background: rgba(255, 255, 255, 0.03);
  padding: 12px;
  margin-bottom: 12px;
`;

export const BalanceCardHeader = styled.button`
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  border-radius: 12px;
  padding: 4px;
  text-align: left;
  background: transparent;
  border: none;
  cursor: pointer;
  transition: background 0.2s ease;
  
  &:hover {
    background: rgba(255, 255, 255, 0.05);
  }
`;

export const BalanceCardLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const WalletIconBox = styled.div`
  display: grid;
  place-items: center;
  width: 32px;
  height: 32px;
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.05);
  color: rgba(255, 255, 255, 0.8);
`;

export const BalanceInfo = styled.div``;

export const BalanceLabel = styled.div`
  font-size: 14px;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.9);
`;

export const BalanceSubtext = styled.div`
  font-size: 12px;
  color: rgba(255, 255, 255, 0.5);
`;

export const BalanceCardRight = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const BalanceAmount = styled.div`
  text-align: right;
`;

export const BalanceValue = styled.div`
  font-size: 14px;
  font-weight: 600;
  color: #fff;
`;

export const BalanceCurrency = styled.div`
  font-size: 11px;
  color: rgba(255, 255, 255, 0.45);
`;

export const Divider = styled.div`
  height: 1px;
  width: 100%;
  background: linear-gradient(to right, transparent, rgba(255, 255, 255, 0.1), transparent);
  margin: 16px 0;
`;

export const TokenBreakdown = styled.div`
  margin-top: 12px;
`;

export const TokenBreakdownHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
`;

export const TokenBreakdownTitle = styled.div`
  font-size: 12px;
  color: rgba(255, 255, 255, 0.55);
`;

export const TokenList = styled.div`
  display: grid;
  gap: 8px;
  margin-top: 8px;
  max-height: 300px;
  overflow-y: auto;
  overflow-x: hidden;
  padding-right: 4px;

  /* Custom scrollbar styling */
  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-track {
    background: rgba(255, 255, 255, 0.05);
    border-radius: 3px;
  }

  &::-webkit-scrollbar-thumb {
    background: rgba(255, 255, 255, 0.2);
    border-radius: 3px;
    transition: background 0.2s ease;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: rgba(255, 255, 255, 0.3);
  }

  /* Firefox scrollbar */
  scrollbar-width: thin;
  scrollbar-color: rgba(255, 255, 255, 0.2) rgba(255, 255, 255, 0.05);
`;

export const TokenItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-radius: 12px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  background: rgba(255, 255, 255, 0.02);
  padding: 12px;
`;

export const TokenSymbol = styled.div`
  font-size: 14px;
  color: rgba(255, 255, 255, 0.8);
`;

export const TokenValue = styled.div`
  font-size: 14px;
  font-weight: 500;
  color: rgba(255, 255, 255, 0.9);
`;

export const ActionButtons = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 12px;
`;

export const PrimaryPill = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  border-radius: 16px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  background: linear-gradient(to right, rgba(6, 182, 212, 0.15), rgba(139, 92, 246, 0.1), rgba(14, 165, 233, 0.15));
  padding: 8px 12px;
  font-size: 14px;
  color: rgba(255, 255, 255, 0.9);
  cursor: pointer;
  transition: all 0.2s ease;
  
  &:hover {
    border-color: rgba(255, 255, 255, 0.2);
    background: rgba(255, 255, 255, 0.1);
  }
  
  &:focus {
    outline: none;
    box-shadow: 0 0 0 2px rgba(6, 182, 212, 0.5);
  }
`;

export const TabContainer = styled.div`
  display: flex;
  gap: 8px;
  margin-top: 12px;
`;

export const TabButton = styled.button`
  flex: 1;
  border-radius: 16px;
  border: 1px solid ${props => props.active ? 'rgba(255, 255, 255, 0.25)' : 'rgba(255, 255, 255, 0.1)'};
  background: ${props => props.active ? 'rgba(255, 255, 255, 0.1)' : 'rgba(255, 255, 255, 0.05)'};
  padding: 8px 12px;
  font-size: 14px;
  color: ${props => props.active ? '#fff' : 'rgba(255, 255, 255, 0.7)'};
  cursor: pointer;
  transition: all 0.2s ease;
  
  &:hover {
    background: rgba(255, 255, 255, 0.1);
  }
  
  &:focus {
    outline: none;
    box-shadow: 0 0 0 2px rgba(6, 182, 212, 0.5);
  }
`;

export const FilterContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 12px;
`;

export const FilterButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  border-radius: 16px;
  border: 1px solid ${props => props.active ? 'rgba(255, 255, 255, 0.25)' : 'rgba(255, 255, 255, 0.1)'};
  background: ${props => props.active ? 'rgba(255, 255, 255, 0.1)' : 'rgba(255, 255, 255, 0.05)'};
  padding: 8px 12px;
  font-size: 14px;
  color: ${props => props.active ? '#fff' : 'rgba(255, 255, 255, 0.7)'};
  cursor: pointer;
  transition: all 0.2s ease;
  
  &:hover {
    background: rgba(255, 255, 255, 0.1);
  }
  
  &:focus {
    outline: none;
    box-shadow: 0 0 0 2px rgba(6, 182, 212, 0.5);
  }
`;

export const ActivityList = styled.div`
  display: grid;
  gap: 12px;
  padding: 16px;
  padding-bottom: 112px;
  overflow-y: auto;
  overflow-x: hidden;
  flex: 1;
  min-height: 0;
  max-height: 100%;

  /* Custom scrollbar styling */
  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-track {
    background: rgba(255, 255, 255, 0.05);
    border-radius: 3px;
  }

  &::-webkit-scrollbar-thumb {
    background: rgba(255, 255, 255, 0.2);
    border-radius: 3px;
    transition: background 0.2s ease;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: rgba(255, 255, 255, 0.3);
  }

  /* Firefox scrollbar */
  scrollbar-width: thin;
  scrollbar-color: rgba(255, 255, 255, 0.2) rgba(255, 255, 255, 0.05);
`;

export const ActivityRow = styled.div`
  border-radius: 16px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  background: rgba(255, 255, 255, 0.02);
  padding: 12px;
  transition: all 0.2s ease;
  
  &:hover {
    transform: translateY(-1px);
    background: rgba(255, 255, 255, 0.05);
  }
`;

export const ActivityContent = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
`;

export const ActivityLeft = styled.div`
  display: flex;
  min-width: 0;
  align-items: flex-start;
  gap: 12px;
`;

export const WalletIconBadge = styled.div`
  margin-top: 2px;
  display: grid;
  place-items: center;
  width: 36px;
  height: 36px;
  border-radius: 16px;
  border: 1px solid;
  flex-shrink: 0;
  background: ${props => {
    if (props.kind === 'virtual') return 'rgba(6, 182, 212, 0.15)';
    if (props.kind === 'onchain') return 'rgba(139, 92, 246, 0.15)';
    return 'rgba(14, 165, 233, 0.15)';
  }};
  border-color: ${props => {
    if (props.kind === 'virtual') return 'rgba(6, 182, 212, 0.3)';
    if (props.kind === 'onchain') return 'rgba(139, 92, 246, 0.3)';
    return 'rgba(14, 165, 233, 0.3)';
  }};
  color: ${props => {
    if (props.kind === 'virtual') return 'rgba(6, 182, 212, 1)';
    if (props.kind === 'onchain') return 'rgba(139, 92, 246, 1)';
    return 'rgba(14, 165, 233, 1)';
  }};
`;

export const ActivityDetails = styled.div`
  min-width: 0;
`;

export const ActivityTitleRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const ActivityTitle = styled.div`
  font-size: 14px;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.9);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const StatusBadge = styled.div`
  border-radius: 999px;
  border: 1px solid;
  padding: 2px 8px;
  font-size: 10px;
  font-weight: 500;
  text-transform: uppercase;
  background: ${props => {
    if (props.status === 'completed') return 'rgba(16, 185, 129, 0.15)';
    if (props.status === 'pending') return 'rgba(245, 158, 11, 0.15)';
    return 'rgba(244, 63, 94, 0.15)';
  }};
  border-color: ${props => {
    if (props.status === 'completed') return 'rgba(16, 185, 129, 0.3)';
    if (props.status === 'pending') return 'rgba(245, 158, 11, 0.3)';
    return 'rgba(244, 63, 94, 0.3)';
  }};
  color: ${props => {
    if (props.status === 'completed') return 'rgba(167, 243, 208, 1)';
    if (props.status === 'pending') return 'rgba(254, 240, 138, 1)';
    return 'rgba(252, 165, 165, 1)';
  }};
`;

export const ActivitySubtitle = styled.div`
  margin-top: 2px;
  font-size: 12px;
  color: rgba(255, 255, 255, 0.55);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const ActivityMeta = styled.div`
  margin-top: 4px;
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 11px;
  color: rgba(255, 255, 255, 0.4);
`;

export const ActivityRight = styled.div`
  flex-shrink: 0;
  text-align: right;
`;

export const ActivityAmount = styled.div`
  font-size: 14px;
  font-weight: 600;
  color: ${props => props.isOut ? 'rgba(252, 165, 165, 1)' : 'rgba(167, 243, 208, 1)'};
`;

export const ActivityActions = styled.div`
  margin-top: 4px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
  opacity: 0;
  transition: opacity 0.2s ease;
  
  ${ActivityRow}:hover & {
    opacity: 1;
  }
`;

export const OrderRow = styled.button`
  width: 100%;
  border-radius: 16px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  background: rgba(255, 255, 255, 0.02);
  padding: 12px;
  text-align: left;
  cursor: pointer;
  transition: all 0.2s ease;
  
  &:hover {
    transform: translateY(-1px);
    background: rgba(255, 255, 255, 0.05);
  }
  
  &:focus {
    outline: none;
    box-shadow: 0 0 0 2px rgba(6, 182, 212, 0.5);
  }
`;

export const OrderContent = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
`;

export const OrderLeft = styled.div`
  min-width: 0;
`;

export const OrderTitleRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const OrderTitle = styled.div`
  font-size: 14px;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.9);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const OrderStatusBadge = styled.div`
  border-radius: 999px;
  border: 1px solid;
  padding: 2px 8px;
  font-size: 10px;
  font-weight: 500;
  text-transform: uppercase;
  background: ${props => {
    if (props.status === 'new') return 'rgba(6, 182, 212, 0.15)';
    if (props.status === 'processing') return 'rgba(139, 92, 246, 0.15)';
    if (props.status === 'shipped') return 'rgba(245, 158, 11, 0.15)';
    if (props.status === 'delivered') return 'rgba(16, 185, 129, 0.15)';
    return 'rgba(244, 63, 94, 0.15)';
  }};
  border-color: ${props => {
    if (props.status === 'new') return 'rgba(6, 182, 212, 0.3)';
    if (props.status === 'processing') return 'rgba(139, 92, 246, 0.3)';
    if (props.status === 'shipped') return 'rgba(245, 158, 11, 0.3)';
    if (props.status === 'delivered') return 'rgba(16, 185, 129, 0.3)';
    return 'rgba(244, 63, 94, 0.3)';
  }};
  color: ${props => {
    if (props.status === 'new') return 'rgba(165, 243, 252, 1)';
    if (props.status === 'processing') return 'rgba(196, 181, 253, 1)';
    if (props.status === 'shipped') return 'rgba(254, 240, 138, 1)';
    if (props.status === 'delivered') return 'rgba(167, 243, 208, 1)';
    return 'rgba(252, 165, 165, 1)';
  }};
`;

export const OrderSubtitle = styled.div`
  margin-top: 2px;
  font-size: 12px;
  color: rgba(255, 255, 255, 0.55);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const OrderMeta = styled.div`
  margin-top: 4px;
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 11px;
  color: rgba(255, 255, 255, 0.4);
  white-space: nowrap;
`;

export const OrderRight = styled.div`
  flex-shrink: 0;
  text-align: right;
`;

export const OrderTotal = styled.div`
  font-size: 14px;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.9);
`;

export const OrderBreakdown = styled.div`
  margin-top: 2px;
  font-size: 11px;
  color: rgba(255, 255, 255, 0.5);
`;

export const OrderActions = styled.div`
  margin-top: 4px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
  opacity: 0;
  transition: opacity 0.2s ease;
  
  ${OrderRow}:hover & {
    opacity: 1;
  }
`;

export const EmptyState = styled.div`
  border-radius: 16px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  background: rgba(255, 255, 255, 0.02);
  padding: 16px;
  font-size: 14px;
  color: rgba(255, 255, 255, 0.6);
  text-align: center;
`;

export const TipBox = styled.div`
  margin-top: 16px;
  border-radius: 16px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  background: rgba(255, 255, 255, 0.02);
  padding: 12px;
  font-size: 12px;
  color: rgba(255, 255, 255, 0.55);
`;

export const TipHighlight = styled.span`
  color: rgba(255, 255, 255, 0.8);
`;

export const SidebarFooter = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  background: rgba(0, 0, 0, 0.4);
  backdrop-filter: blur(12px);
`;

export const FooterContent = styled.div`
  padding: 12px 16px;
  padding-bottom: calc(env(safe-area-inset-bottom, 0px) + 12px);
`;

export const FooterActions = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
`;

export const FooterText = styled.div`
  margin-top: 8px;
  font-size: 11px;
  color: rgba(255, 255, 255, 0.35);
`;

export const OrderDropdownContainer = styled.div`
  position: relative;
  margin-top: 12px;
`;

export const OrderDropdownButton = styled.button`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 12px;
  border-radius: 12px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  background: rgba(255, 255, 255, 0.05);
  color: rgba(255, 255, 255, 0.9);
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s ease;
  
  &:hover {
    background: rgba(255, 255, 255, 0.1);
    border-color: rgba(255, 255, 255, 0.2);
  }
  
  &:focus {
    outline: none;
    box-shadow: 0 0 0 2px rgba(6, 182, 212, 0.5);
  }
`;

export const OrderDropdownMenu = styled.div`
  position: absolute;
  top: calc(100% + 4px);
  left: 0;
  right: 0;
  z-index: 1000;
  border-radius: 12px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  background: rgba(7, 11, 20, 0.98);
  backdrop-filter: blur(12px);
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.5);
  overflow: hidden;
`;

export const OrderDropdownItem = styled.button`
  width: 100%;
  display: flex;
  align-items: center;
  padding: 10px 12px;
  border: none;
  background: ${props => props.active ? 'rgba(6, 182, 212, 0.15)' : 'transparent'};
  color: ${props => props.active ? 'rgba(165, 243, 252, 1)' : 'rgba(255, 255, 255, 0.9)'};
  font-size: 14px;
  text-align: left;
  cursor: pointer;
  transition: all 0.2s ease;
  
  &:hover {
    background: ${props => props.active ? 'rgba(6, 182, 212, 0.2)' : 'rgba(255, 255, 255, 0.05)'};
  }
  
  &:not(:last-child) {
    border-bottom: 1px solid rgba(255, 255, 255, 0.05);
  }
`;
